import contentControls from "./contentControlsService"
import { HTML_CONTENT_BLOCK } from "@/constants/contentControlTypes";
import { HTML_CONTENT_BLOCK as SECTION_COLOR } from "@/constants/contentControlColors";
import { tryLoadProperties } from "@/util/wordUtil";

const add = (systemName, content, displayName = "", hideBoundingBox = false) => new Promise(resolve => {
    if (!displayName) {
        displayName = systemName
    }

    const title = `Sharedo ${HTML_CONTENT_BLOCK}: ${displayName}`;
    const options = {
        color: SECTION_COLOR,
        tag: systemName,
        hideBoundingBox
    };

    contentControls.insert(title, options, async ({ contentControl, parentContentControl, context }) => {
        contentControl.insertHtml(content, "Replace");
        await context.sync();

        tryLoadProperties(context, contentControl, "id").then(() => {
            const retVal = { id: contentControl.id };

            if (parentContentControl) {
                retVal.parentId = parentContentControl.id;
            }

            resolve(retVal);
        });
    });
});

export default {
    add
}